export const ADDED_TO_BAG_TOAST = 'ADDED_TO_BAG_TOAST'
export const ROTATE_PHONE = 'ROTATE_PHONE'
